
// #721 spec §8.4 / A.11: only the coverage lines that change; a move compares
// everything; one column per option (round-2 spec §13.2). Cells are engine HTML (escaped); "Not confirmed" for a supp
// premium the client has not given us.
import card from '~/mixins/card'
import { compareRows } from '~/util/aep-recommendation'

export default {
    mixins: [card],
    computed: {
        table () {
            return this.aepContext ? compareRows(this.aepContext) : null
        },
    },
}
